module.exports = __webpack_public_path__ + "static/media/new-message.b3a062de.svg";